import React from 'react';
import Card from '@/components/common/Card';
import Button from '@/components/common/Button';
import logger from '@/services/logger';

interface ResultsWindowProps {
  windowId: string;
}

/**
 * Analysis results window component
 * Displays the results of email analysis
 */
const ResultsWindow: React.FC<ResultsWindowProps> = ({ windowId }) => {
  // Placeholder data - in a real implementation, this would come from the Redux store
  const mockResults = {
    score: 85,
    status: 'Suspicious',
    findings: [
      { type: 'Sender', message: 'Sender domain does not match display name', severity: 'high' },
      { type: 'Links', message: 'Contains suspicious URL redirection', severity: 'high' },
      { type: 'Content', message: 'Urgent language detected', severity: 'medium' },
    ]
  };

  const handleExport = () => {
    logger.info('Results export requested', { module: 'windows', data: { windowId } });
  };

  return (
    <div className="h-full flex flex-col">
      <div className="flex-grow p-4 overflow-auto">
        <div className="mb-4">
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-semibold">Analysis Results</h3>
            <div className={`px-3 py-1 rounded-full text-white ${
              mockResults.score > 80 ? 'bg-red-500' : 
              mockResults.score > 50 ? 'bg-yellow-500' : 'bg-green-500'
            }`}>
              {mockResults.status}
            </div>
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-400">
            Risk Score: {mockResults.score}/100
          </div>
        </div>

        <div className="space-y-3">
          <h4 className="font-medium">Key Findings:</h4>
          {mockResults.findings.map((finding, index) => (
            <Card key={index} className="border">
              <Card.Body className="p-3">
                <div className="flex items-start">
                  <div className={`w-2 h-2 mt-1.5 rounded-full mr-2 ${
                    finding.severity === 'high' ? 'bg-red-500' : 
                    finding.severity === 'medium' ? 'bg-yellow-500' : 'bg-blue-500'
                  }`} />
                  <div>
                    <div className="font-semibold">{finding.type}</div>
                    <div className="text-sm">{finding.message}</div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
      
      <div className="p-2 border-t flex justify-end">
        <Button 
          variant="primary" 
          size="small"
          onClick={handleExport}
        >
          Export Results
        </Button>
      </div>
    </div>
  );
};

export default ResultsWindow; 